
<app-add-todo
  (add)="add($event)"
></app-add-todo>
<app-todo-item
  *ngFor="let todo of todos"
  [todo]="todo"
  (delete)="delete($event)"
></app-todo-item>
